import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

// SPA entry. Mounts into the #root element declared in index.html.
const container = document.getElementById("root");
if (!container) throw new Error("root element missing");

createRoot(container).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
